export default "__VITE_ASSET__CHwjO7Ik__"